import { render, staticRenderFns } from "./ContractsGrid.vue?vue&type=template&id=11ded638"
import script from "./ContractsGrid.vue?vue&type=script&lang=js"
export * from "./ContractsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports